import { Fragment } from "react";
import { FiTrash2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { addToCart, CartType, removeFromCart, updateFromCart } from "slices/cart";
import './index.scss'

interface CartItemType {
    item: CartType
}

export function CartItem({ item }: CartItemType) {
    const dispatch = useDispatch()

    const actual_price = () => {
        let price_removed = Math.round(((item.discount || 0) / 100) * item.price).toFixed(0)
        let main_price = parseFloat(`${item.price}`) - parseFloat(price_removed)

        return main_price
    }

    const total_price = () => {
        let main_prc = actual_price() * (item.amount || 1)
        let mp = `${(Math.round(main_prc * 100) / 100).toFixed(2)}`

        return parseFloat(mp)
    }

    function handleUpdateCart() {
        const _item: CartType = {
            ...item,
            amount: item.amount - 1
        }
        dispatch(updateFromCart(_item))
    }

    function handleRemoveFromCart() {
        dispatch(removeFromCart(item.id))
        console.log('cart-item-remove')
    }


    return (
        <Fragment>

            <div className="border-bottom CartItem">
                <div className="CartItem_left">
                    <img src={item.img} alt="" className="CartItem_left_logo" />
                </div>

                <div className="CartItem_right">
                    <div className="CartItem_right-name">{item.name}</div>
                    <div className="CartItem_right-title">item price ${actual_price()}</div>
                    <div className="CartItem_right-bottom">
                        <div className="CartItem_right-bottom-price">${total_price()}</div>
                        <div className="CartItem_right-bottom-inc-dec">
                            <span className="dec" onClick={handleUpdateCart}>-</span>
                            <span className="qty">{item.amount}</span>
                            <span className="inc" onClick={() => dispatch(addToCart(item))}>+</span>
                        </div>
                        <i className="CartItem_right-bottom-del" onClick={handleRemoveFromCart}>
                            <FiTrash2 />
                        </i>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
